var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 40.3125C17.9375 40.3125 20.9375 37.3125 20.9375 33.5938V26.875H14.2188C10.5 26.875 7.5 29.875 7.5 33.5938C7.5 37.3125 10.5 40.3125 14.2188 40.3125Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.1562C7.5 16.4375 10.5 13.4375 14.2188 13.4375H20.9375V26.875H14.2188C10.5 26.875 7.5 23.875 7.5 20.1562Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.71875C7.5 3 10.5 0 14.2188 0H20.9375V13.4375H14.2188C10.5 13.4375 7.5 10.4375 7.5 6.71875Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 0H27.6562C31.375 0 34.375 3 34.375 6.71875C34.375 10.4375 31.375 13.4375 27.6562 13.4375H20.9375V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 20.1562C34.375 23.875 31.375 26.875 27.6562 26.875C23.9375 26.875 20.9375 23.875 20.9375 20.1562C20.9375 16.4375 23.9375 13.4375 27.6562 13.4375C31.375 13.4375 34.375 16.4375 34.375 20.1562Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.6f8dca3ef9a58b38d0c25ad90dad0706.svg";
export { ForwardRef as ReactComponent };